import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

function HomePage() {
  const navigate = useNavigate();

  const menuItems = [
    {
      id: 'chat',
      title: 'チャット',
      description: 'マニュアル・数字・対応を聞く',
      path: '/chat',
    },
    {
      id: 'upload',
      title: 'ドキュメント管理',
      description: 'ファイルや知識をアップロード',
      path: '/upload',
    },
    {
      id: 'history',
      title: '会話履歴',
      description: '過去の会話を確認',
      path: '/history',
    },
  ];

  return (
    <div className="home-page">
      <header className="home-header">
        <div className="home-header-inner">
          <div className="home-brand">
            <div className="home-brand-name">MOMIBO</div>
            <div className="home-brand-sub">本部サポート</div>
          </div>
          <a className="hq-home-link" href="/auth/dashboard">
            本部ホーム
          </a>
        </div>
      </header>

      <div className="home-container">
        <div className="home-title-box">
          <h1 className="commissioner-title-text">なにかお手伝いできますか？</h1>
          <p className="home-subtitle">チャットから質問するか、下のメニューを選んでください。</p>
        </div>

        <div className="cta-row">
          <a href="/auth/dashboard" className="hq-home-link hq-home-link-large">
            本部ホームを開く
          </a>
        </div>

        <div className="menu-grid">
          {menuItems.map((item) => (
            <button
              key={item.id}
              type="button"
              className="menu-card"
              onClick={() => navigate(item.path)}
            >
              <h3 className="menu-title">{item.title}</h3>
              <p className="menu-description">{item.description}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
